import React, { useContext, useState, useRef, useEffect } from 'react';
import ResponsiveBox, {
  Row, Col, Item, Location,
} from 'devextreme-react/responsive-box';
import TenantContext from '../../contexts/tenantContext';
import Button from 'devextreme-react/button';
import Toolbar, { Item as ToolbarItem } from 'devextreme-react/toolbar';
import { DataGrid, Column, Editing, Paging, GroupPanel } from 'devextreme-react/data-grid';
import notify from 'devextreme/ui/notify';
import { EmergenzaDTO, EmergenzeApi } from '../../data';
import { apiConfiguration } from '../../apiConfig';
import { LoadPanel, Tabs } from 'devextreme-react';
import CurrentEmergenzaMapPanel from '../../components/emergenzaOperatore/CurrentEmergenzaMapPanel';
import { CollapsablePanel } from '../../components/collapsablePanel/CollapsablePanel';
import CurrentEmergenzaListaAssistitiPanel from '../../components/emergenzaOperatore/CurrentEmergenzaListaAssistitiPanel';


export default function EmergenzaOperatore() {
  const { currentTenant } = useContext(TenantContext);
  const [emergenza, setEmergenza] = useState<EmergenzaDTO | null | undefined>();
  const [loading, setLoading] = React.useState<boolean>(true);
  const [title, setTitle] = React.useState<string>("Gestione Emergenza");
  const tabs = ["Elenco soccorsi", "Mappa"];
  const [currentTab, setCurrentTab] = React.useState<string>(tabs[0]);

  const refreshData = async () => {
    var api = new EmergenzeApi(apiConfiguration);

    var emergenza = await api.getCurrentEmergenza({ tenantId: currentTenant.Id });
    setEmergenza(emergenza);

    if (emergenza)
      setTitle("Gestione Emergenza - " + emergenza.nome);
    else
      setTitle("Gestione Emergenza");
  };

  useEffect(() => {
    setLoading(true);

    refreshData()
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [currentTenant]);

  return (
    <React.Fragment>
      <h2 className={'content-block'}>{title}</h2>
      <div className={'content-block'}>
        <div className={'dx-card responsive-paddings'}>
          {!loading && emergenza?.id &&
            <React.Fragment>
              <Tabs
                dataSource={tabs}
                selectedItem={currentTab}
                onSelectedItemChange={e => setCurrentTab(e)}
                stylingMode='primary'
                width={'100%'}
              />

              {currentTab === "Elenco soccorsi" &&
                <CurrentEmergenzaListaAssistitiPanel emergenzaId={emergenza.id} />
              }

              {currentTab === "Mappa" &&
                <CurrentEmergenzaMapPanel />
              }

            </React.Fragment>
          }

          {!loading && !emergenza?.id &&
            <div>
              Nessuna emergenza in corso
            </div>
          }

          <LoadPanel
            shadingColor="rgba(0,0,0,0.4)"
            position={{ of: '.dx-card' }}
            visible={loading}
            showIndicator={true}
            shading={false}
            showPane={true}
            hideOnOutsideClick={false}
          />
        </div>
      </div>
    </React.Fragment>
  )
}
